import { useEffect, useState } from 'react'
import { fetchAppAnalytics } from '../services/api'
import type { AppAnalyticsData } from '../types'

export default function AppAnalytics() {
  const [data, setData] = useState<AppAnalyticsData[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchAppAnalytics()
      .then(setData)
      .finally(() => setLoading(false))
  }, [])

  return (
    <div>
      <h2 className="text-3xl font-bold text-white mb-8">App Analytics</h2>
      
      {loading ? (
        <div className="text-gray-400">Loading...</div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
              <h3 className="text-sm font-medium text-gray-400 mb-2">Total Downloads</h3>
              <p className="text-3xl font-bold text-white">
                {data.reduce((sum, d) => sum + d.downloads, 0).toLocaleString()}
              </p>
            </div>
            <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
              <h3 className="text-sm font-medium text-gray-400 mb-2">Active Users</h3>
              <p className="text-3xl font-bold text-white">
                {data.reduce((sum, d) => sum + d.activeUsers, 0).toLocaleString()}
              </p>
            </div>
            <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
              <h3 className="text-sm font-medium text-gray-400 mb-2">Crash Rate</h3>
              <p className="text-3xl font-bold text-white">
                {(data.reduce((sum, d) => sum + d.crashRate, 0) / data.length || 0).toFixed(2)}%
              </p>
            </div>
          </div>

          <div className="bg-gray-800 rounded-lg border border-gray-700 overflow-hidden">
            <table className="min-w-full divide-y divide-gray-700">
              <thead className="bg-gray-700">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">App Name</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Downloads</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Active Users</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Sessions</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Crash Rate</th>
                </tr>
              </thead>
              <tbody className="bg-gray-800 divide-y divide-gray-700">
                {data.map((row, idx) => (
                  <tr key={idx}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-white font-medium">{row.appName}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-300">{row.downloads.toLocaleString()}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-300">{row.activeUsers.toLocaleString()}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-300">{row.sessions.toLocaleString()}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-white">{row.crashRate.toFixed(2)}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  )
}
